import React from "react";

export const WarningIcon = () => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.2659 17.9981H1.73288C1.37562 17.9981 1.04551 17.8075 0.866878 17.4981C0.688252 17.1887 0.688254 16.8075 0.866885 16.4981L10.1329 0.498114C10.3117 0.189226 10.6415 -0.000976562 10.9984 -0.000976562C11.3553 -0.000976562 11.6851 0.189226 11.8639 0.498114L21.1299 16.4981C21.3084 16.8074 21.3085 17.1883 21.1301 17.4977C20.9518 17.807 20.622 17.9977 20.2649 17.9981H20.2659ZM10.9999 2.99811L3.46888 15.9981H18.5329L10.9999 2.99811ZM11.9949 11.9991H9.99488V6.99811H11.9949V11.9991Z" fill="white" />
    <path d="M9.99988 13.0001H11.9999V15.0001H9.99988V13.0001Z" fill="white" />
  </svg>
)
